import { render } from "./FilterRule.vue?vue&type=template&id=5b06b591"
import script from "./FilterRule.vue?vue&type=script&lang=js"
export * from "./FilterRule.vue?vue&type=script&lang=js"
script.render = render

export default script